// extracted by mini-css-extract-plugin
export default {"container":"CmsVotingWidget-module__container-C4i2S2"};